import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImportedInvoiceDetailAccordionHeader = styled.button`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  width: 100%;
  padding: ${Spacing.S8} ${Spacing.S24} 0;
  border: none;
  background: none;
  color: inherit;
  text-align: left;
  cursor: pointer;
`

export const ImportedInvoiceDetailAccordionChevron = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
`

export const ImportedInvoiceDetailAccordionBody = styled.div`
  padding-top: ${Spacing.S8};
`
